export const PLAN_NAME_MIN = 3;
export const PLAN_NAME_MAX = 80;

const PLAN_NAME_INVALID_CHARS = /[<>{}]/;

export const validatePlanName = (name, existingNames = []) => {
  const trimmed = name.trim();

  if (!trimmed) return "Plan name is required";
  if (trimmed.length < PLAN_NAME_MIN)
    return `Plan name must be at least ${PLAN_NAME_MIN} characters`;
  if (trimmed.length > PLAN_NAME_MAX)
    return `Plan name must be under ${PLAN_NAME_MAX} characters`;
  if (PLAN_NAME_INVALID_CHARS.test(trimmed))
    return "Plan name can't contain < > { } characters";
  if (existingNames.some((n) => n.trim().toLowerCase() === trimmed.toLowerCase()))
    return "A plan with this name already exists";

  return null; // valid
};

export const validateBrand = (brand) => {
  if (!brand) return "Select a brand";
  return null;
};

export const hasErrors = (errors) => Object.values(errors).some(Boolean);